import Logo from "./Logo";
import NavBar from "./NavBar";
import TestTitle from "./TestTitle";

import "../styles/Header.css";

export default function FourHHeader() {
  return (
    <header className="fourHHeader">
      <div className="headerLogoDiv">
        <Logo />
      </div>

      <div className="headerTitleDiv">
        <TestTitle />
      </div>

      <div className="headerNavDiv">
        <NavBar />
      </div>
    </header>
  );
}